import * as React from "react";
import { useTableHeaderRow, useTableRow } from "@react-aria/table";
import { GhostButton, IconButton } from "@bolteu/kalep-react";
import { cx } from "../utils/cx";
import { DefaultCellContent } from "./CellContent";
function DefaultRowActions(props) {
    const { action } = props;
    const label = typeof action.label === "function" ? action.label(props) : action.label;
    const icon = typeof action.icon === "function" ? action.icon(props) : React.cloneElement(action.icon, { size: "sm" });
    const onClick = React.useCallback((event) => {
        var _a;
        if (props.isRowClickable) {
            event.stopPropagation();
        }
        (_a = action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, props);
    }, [action, props]);
    if (props.compact) {
        return (React.createElement(GhostButton, { "aria-label": label, onClick: onClick },
            React.createElement("div", { className: cx("text-secondary hover:text-primary") }, icon)));
    }
    return (React.createElement(IconButton, { size: "sm", variant: "ghost", overrideClassName: cx("text-secondary"), "aria-label": label, icon: icon, onClick: onClick }));
}
export function RowActions({ actions, row, compact, isRowClickable }) {
    return (React.createElement(DefaultCellContent, { compact: compact, className: cx("inline-flex justify-end gap-1") }, actions.map((action) => {
        const key = typeof action.label === "function" ? action.label({ row, action }) : action.label;
        return action.customInlineRenderer ? (action.customInlineRenderer({ row, action })) : (React.createElement(DefaultRowActions, { key: key, action: action, row: row, compact: compact, isRowClickable: isRowClickable }));
    })));
}
export function HeaderRow({ rowItem, state, children }) {
    const ref = React.useRef(null);
    const { rowProps } = useTableHeaderRow({ node: rowItem }, state, ref);
    return (React.createElement("tr", Object.assign({}, rowProps, { ref: ref }), children));
}
export function Row({ rowItem, children, state, striped, onRowClick, getRowStyle, getRowClassName, }) {
    const ref = React.useRef(null);
    const isSelected = state.selectionManager.isSelected(rowItem.key);
    const { rowProps } = useTableRow({ node: rowItem }, state, ref);
    const isClickable = !!onRowClick;
    const rowContext = { row: rowItem.value, isSelected, isClickable, isStriped: !!striped };
    const customClassList = (getRowClassName === null || getRowClassName === void 0 ? void 0 : getRowClassName(rowContext)) || "";
    const customStyle = (getRowStyle === null || getRowStyle === void 0 ? void 0 : getRowStyle(rowContext)) || undefined;
    const onClick = React.useCallback(() => onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(rowItem.value), [onRowClick, rowItem]);
    return (React.createElement("tr", Object.assign({}, rowProps, { className: cx("bg-special-nulled hover:bg-active-neutral-secondary", striped && "odd:bg-special-zebra", isSelected && "bg-action-secondary hover:bg-action-secondary", isClickable && "cursor-pointer", customClassList), ref: ref, onClick: onClick, style: customStyle }), children));
}
